/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make words from your letters`)
};

const es_wu_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forma palabras con tus letras`)
};

const de_wu_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilde Wörter aus deinen Buchstaben`)
};

const nl_wu_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak woorden met jouw letters`)
};

const fr_wu_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formez des mots avec vos lettres`)
};

const it_wu_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea parole con le tue lettere`)
};

const pt_br2_wu_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forme palavras com suas letras`)
};

const pt_wu_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forme palavras com as suas letras`)
};

const ja_wu_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手持ちの文字から単語を作る`)
};

const zh_wu_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用你的字母拼出单词`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_nav_main_desc", locale)
	if (locale === "en") return en_wu_nav_main_desc(inputs)
	if (locale === "es") return es_wu_nav_main_desc(inputs)
	if (locale === "de") return de_wu_nav_main_desc(inputs)
	if (locale === "nl") return nl_wu_nav_main_desc(inputs)
	if (locale === "fr") return fr_wu_nav_main_desc(inputs)
	if (locale === "it") return it_wu_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_wu_nav_main_desc(inputs)
	if (locale === "pt") return pt_wu_nav_main_desc(inputs)
	if (locale === "ja") return ja_wu_nav_main_desc(inputs)
	return zh_wu_nav_main_desc(inputs)
};